/* globals Cookies getParameterByName */
(() => {
    let bypass = getParameterByName('bypass-form');
    let src = getParameterByName('src');

    document.addEventListener('DOMContentLoaded', function () {
        let marketoCookieValue = Cookies.get('marketoCookie');

        if ($('.resource-container.first.form-container-js').not('.webinar-form').length) {
            if (marketoCookieValue === 'true' || bypass === 'true' || src === 'portal') {
                // hide form container
                $('.resource-container.first.form-container-js').removeClass('show').addClass('hidden');
                // show download container
                $('.resource-container.download-options').removeClass('hidden').addClass('show');
            }
        }
    });
})();
